<template>
  <section>
    <span>{{ report }}</span>
  </section>
</template>
<script lang="ts" setup>
import { AnyInformationResponse } from '@/api-client/models/shared/Contracts'
import { useResultReportNew } from '../useResultReport'
import { computed } from 'vue'
type Props = {
  information: AnyInformationResponse | undefined
}
const props = defineProps<Props>()
const information = computed(() => props.information)
const { report } = useResultReportNew(information)
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
section {
  margin-top: 16px;
}
span {
  @include font-mixins.desktop-regular-label;
  color: variables.$color-greyscale-content;
  display: flex;
  flex-direction: row;
  gap: variables.$gap-xlarge;
}
</style>
```
